import Vue from 'vue'
import Router from 'vue-router'
import index from 'views/course/index'
import login from 'views/login/login'
import loginMp from 'views/h5/login-mp'
import register from 'views/register/register'
import forgot from 'views/register/forgot'
import me from 'views/me/me'
import userInfo from 'views/me/user-info'
import userAuth from 'views/me/user-auth'
import userAuthSuccess from 'views/me/user-auth-success'
import userAuthFailure from 'views/me/user-auth-failure'
import userActivateSuccess from 'views/me/user-activate-success'
import userActivateFailure from 'views/me/user-activate-failure'
import classroom from 'views/classroom/index'
import lesson from 'views/classroom/classroom'
import lessonInfo from 'views/classroom/lesson-info'
import schedule from 'views/schedule/schedule'
import booking from 'views/booking/booking'
import paymentIndex from 'views/payment/index'
import payment from 'views/payment/payment'
import paymentInfo from 'views/payment/paymentInfo'
import paymentList from 'views/payment/paymentList'
import homeMp from 'views/h5/home-mp'
import meMp from 'views/h5/me-mp'
import courseMp from 'views/h5/course-mp'
import bookingMp from 'views/h5/booking-mp'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/index',
      meta: {
        title: 'Home'
      }
    },
    {
      path: '/index',
      component: index,
      meta: {
        title: 'Home'
      }
    },
    {
      path: '/login',
      component: login,
      meta: {
        title: 'Login'
      }
    },
    {
      path: '/m/login',
      component: loginMp,
      meta: {
        title: '绑定 Binding'
      }
    },
    {
      path: '/m/home',
      component: homeMp,
      meta: {
        title: '教师主页'
      }
    },
    {
      path: '/m/me',
      component: meMp,
      meta: {
        title: '个人信息'
      }
    },
    {
      path: '/m/booking',
      component: bookingMp,
      meta: {
        title: '开放时间'
      }
    },
    {
      path: '/m/course',
      component: courseMp,
      meta: {
        title: '课程详情'
      }
    },
    {
      path: '/register',
      component: register,
      meta: {
        title: 'Register'
      }
    },
    {
      path: '/forgot',
      component: forgot,
      meta: {
        title: 'Forgot'
      }
    },
    {
      path: '/me',
      component: me,
      meta: {
        title: 'Me'
      }
    },
    {
      path: '/userInfo',
      component: userInfo,
      meta: {
        title: 'UserInfo'
      }
    },
    {
      path: '/userAuth',
      component: userAuth,
      meta: {
        title: 'UserAuth'
      }
    },
    {
      path: '/userAuthSuccess',
      component: userAuthSuccess,
      meta: {
        title: 'UserAuthSuccess'
      }
    },
    {
      path: '/userAuthFailure',
      component: userAuthFailure,
      meta: {
        title: 'UserAuthFailure'
      }
    },
    {
      path: '/userActivateSuccess',
      component: userActivateSuccess,
      meta: {
        title: 'UserActivateSuccess'
      }
    },
    {
      path: '/userActivateFailure',
      component: userActivateFailure,
      meta: {
        title: 'UserActivateFailure'
      }
    },
    {
      path: '/classroom',
      component: classroom,
      redirect: '/classroom/lesson',
      children: [
        {
          path: 'lesson',
          component: lesson,
          meta: {
            title: 'ClassRoom'
          }
        },
        {
          path: 'lessonInfo',
          component: lessonInfo,
          meta: {
            title: 'LessonInfo'
          }
        }
      ]
    },
    {
      path: '/payment',
      component: paymentIndex,
      redirect: '/payment/payment',
      children: [
        {
          path: 'payment',
          component: payment,
          meta: {
            title: 'payment'
          }
        },
        {
          path: 'paymentInfo',
          component: paymentInfo,
          meta: {
            title: 'paymentInfo'
          }
        },
        {
          path: 'paymentList',
          component: paymentList,
          meta: {
            title: 'paymentList'
          }
        }
      ]
    },
    {
      path: '/schedule',
      component: schedule,
      meta: {
        title: 'Schedule'
      }
    },
    {
      path: '/booking',
      component: booking,
      meta: {
        title: 'Booking'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js